<mat-form-field appearance="fill-customize"  floatLabel="never">
	<mat-label *ngIf="name">{{ name | uppercase}}</mat-label>
		<mat-select
			id="{{ id }}"
			[disabled]="disabled"
			disableOptionCentering="true"
			placeholder="{{ placeholder }}"
			[(ngModel)]="selectedValue"> 
			<mat-option
				*ngFor="let item of list; let i = index"
				[value]="i"
				(click)="closeDropdown({ value: i, hideList: false })"
				id="{{ item.text }}"
			>
				{{ item.text }}
			</mat-option>
		</mat-select>
</mat-form-field>